import React from "react";
import PropTypes from "prop-types";
import {Link, useNavigate, useLocation} from "react-router-dom";
// import AppMenuItem from "./AppMenuItem";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Collapse,
  ListItemButton
} from "@mui/material";
import {makeStyles, createStyles} from "@mui/styles";
import MDBox from "components/MDBox";

// React runtime PropTypes

const AppMenuItem = ({name, Icon, link, items = [], openItem, setOpenItem}) => {
  const classes = useStyles();
  const isExpandable = items && items.length > 0;
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = location.pathname === link;
  const isOpen = openItem === name;

  const handleClick = () => {
    if (isExpandable) {
      setOpenItem(isOpen ? null : name);
    } else if (link) {
      navigate(link);
    }
  };

  return (
    <>
    {isExpandable ? (
      <ListItemButton
        onClick={handleClick}
        selected={isActive}
        className={`${classes.menuItem} ${isActive ? classes.activeMenuItem : ""}`}
        style={{
          padding: "8px 12px",
          width: "calc(100% - 16px)",
          margin: "4px 8px",
          borderRadius: "10px"
        }}
      >
        {!!Icon && (
          <ListItemIcon className={classes.menuItemIcon}>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText
          primary={name}
          inset={!Icon}
          sx={{
            marginLeft: 0,
            "& .MuiTypography-root": {
              fontSize: "0.95rem",
              fontWeight: 400,
              padding: "10px",
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.5
            }
          }}
        />
        {isExpandable && (isOpen ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
    ) : (
      <ListItemButton
        component={Link}
        to={link}
        selected={isActive}
        className={`${classes.menuItem} ${isActive ? classes.activeMenuItem : ""}`}
        style={{
          padding: "8px 12px",
          width: "calc(100% - 16px)",
          margin: "4px 8px",
          borderRadius: "10px"
        }}
      >
        {!!Icon && (
          <ListItemIcon className={classes.menuItemIcon}>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText
          primary={name}
          inset={!Icon}
          sx={{
            marginLeft: 0,
            "& .MuiTypography-root": {
              fontSize: "0.95rem",
              fontWeight: 400,
              padding: "10px",
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.5
            }
          }}
        />
      </ListItemButton>
    )}

      {isExpandable && (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Divider />
          <List component="nav" disablePadding style={{marginTop: "-25px", marginLeft: "-10px"}}>
            {items.map((item, index) => (
              <AppMenuItem {...item} key={index} openItem={openItem} setOpenItem={setOpenItem} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

const drawerWidth = 240;
const useStyles = makeStyles(() =>
  createStyles({
    menuItem: {
      color: "black !important",
      transition: "background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease",
      "&:hover": {
        color: "white !important",
        background: "linear-gradient(135deg, #53B0E0, #2D2EAA) !important",
        boxShadow: "0 4px 12px rgba(24, 54, 122, 0.2)",
        "& .MuiListItemIcon-root": {
          color: "white !important"
        }
      }
    },
    activeMenuItem: {
      background: "linear-gradient(135deg, #53B0E0, #2D2EAA) !important",
      color: "white !important",
      boxShadow: "0 4px 12px rgba(24, 54, 122, 0.25)"
    },
    menuItemIcon: {
      color: "black !important",
      minWidth: "0 !important"
    }
  })
);

AppMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  Icon: PropTypes.elementType,
  items: PropTypes.array,
  openItem: PropTypes.string,
  setOpenItem: PropTypes.func
};

export default AppMenuItem;
